import { Dictionary } from "@/types";
import { ComponentAuthoritiesInfo } from "@/lib/types";

const config: Dictionary<ComponentAuthoritiesInfo> = {
  BlockProfileInformation: {
    get_any: ["getAnyUserInfo"],
    get_my: ["getMyUserInfo"],
    set_any: ["updateAnyUserInfo"],
    set_my: ["updateMyUserInfo"],
    roles: ["client", "admin"],
  },
  BlockPersonalInformation: {
    get_any: ["getAnyPersonalInfo"],
    get_my: ["getMyPersonalInfo"],
    set_any: ["updateAnyPersonalInfo"],
    set_my: ["updateMyPersonalInfo"],
    roles: ["client"],
  },
  BlockRegistrationInformation: {
    get_any: ["getAnyUserInfo"],
    get_my: ["getMyUserInfo"],
    roles: ["client", "admin"],
  },
  BlockCompanyInformation: {
    update_any: ["uploadAnyPublicFile"],
    roles: [],
  },
  BlockFraudStatus: {
    get_any: ["getAnyFraudInfo"],
    get_my: ["getMyFraudInfo"],
    set_any: ["updateAnyFraudInfo"],
    set_my: ["updateMyFraudInfo"],
    roles: ["client"],
  },
  BlockQuestionaryInformation: {
    get_any: [],
    get_my: [],
    set_any: ["updateAnyQuestionaryInfo"],
    set_my: ["updateMyQuestionaryInfo"],
    roles: ["client"],
  },
  BlockPayeeInformation: {
    get_any: ["getAnyPayeeInfo"],
    get_my: ["getMyPayeeInfo"],
    set_any: ["updateAnyPayeeInfo"],
    set_my: ["updateMyPayeeInfo"],
    roles: ["client", "talent_agent"],
  },
  BlockclientsByTalentRep: {
    get_any: [],
    get_my: [],
    set_any: [],
    set_my: [],
    roles: ["talent_agent"],
  },
  BlockEarnings: {
    get_any: [],
    get_my: [],
    set_any: ["updateAnyMessagePrice"],
    set_my: ["updateMyMessagePrice"],
    roles: ["client"],
  },
  BlockUserNotes: {
    get_any: ["getAnyUserNotes"],
    get_my: ["getMyUserNotes"],
    set_any: ["updateAnyUserNotes"],
    set_my: ["updateMyUserNotes"],
    roles: ["client"],
  },
  BlockUserFiles: {
    update_any: ["updateAnyFile"],
    update_my: ["updateMyFile"],
    roles: ["client"],
  },
  BlockSubscriptions: {
    get_any: ["getAnySubscription"],
    get_my: ["getMySubscription"],
    set_any: ["updateAnyRecurringBillingSchedule"],
    set_my: ["updateMyRecurringBillingSchedule"],
    roles: ["client"],
  },
  BlockSubscribers: {
    get_any: ["getAnyRecurringBillingSchedule"],
    get_my: ["getMyRecurringBillingSchedule"],
    set_any: ["updateAnyRecurringBillingSchedule"],
    set_my: ["updateMyRecurringBillingSchedule"],
    roles: ["client"],
  },
  BlockUserTags: {
    create_any: ["createUserTag"],
    get_any: [],
    get_my: [],
    set_any: ["updateUserTag"],
    set_my: ["updateUserTag"],
    del_any: ["deleteUserTag"],
    roles: ["client"],
  },
  BlockBlockedLocations: {
    set_any: ["createAnyBlockedLocation"],
    set_my: ["createMyBlockedLocation"],
    roles: ["client"],
  },
  BlockBlockedUsersList: {
    set_any: ["updateAnyUserBlockingStatus"],
    set_my: ["updateMyUserBlockingStatus"],
    get_any: ["getAnyUserBlockingStatus"],
    get_my: ["getMyUserBlockingStatus"],
    roles: ["client"],
  },
  BlockBlockedLocationsInfo: {
    get_any: ["getAllBlockedLocations"],
    get_my: ["getMyBlockedLocations"],
    del_any: ["deleteAnyBlockedLocation"],
    del_my: ["deleteMyBlockedLocation"],
    roles: ["client"],
  },
  DomainSetting: {
    get_any: ["getManagerToken"],
    roles: [],
  },
  UpdateAvatar: {
    update_any: ["updateAnyFile"],
    update_my: ["updateMyFile"],
    roles: [],
  },
  contentSet: {
    create_any: ["createAnyContentSet"],
    create_my: ["createMyContentSet"],
    update_any: ["updateAnyContentSet"],
    update_my: ["updateMyContentSet"],
    delete_any: ["deleteAnyContentSet"],
    delete_my: ["deleteMyContentSet"],
    get_any: ["getAnyContentSet"],
    get_my: ["getMyContentSet"],
    roles: ["client"],
  },
  Transactions: {
    create_any: ["createManualTransaction"],
    get_any: ["getAnyTransaction"],
    get_my: ["getMyTransaction"],
    roles: ["client"],
  },
  StaticPages: {
    update_any: ["updateAnyPage"],
    roles: [],
  },
  PaymentSystem: {
    get_any: ["getAnyPaymentSystem"],
    update_any: ["updateAnyPaymentSystem"],
    roles: [],
  },
  PaymentPackages: {
    get_any: [],
    update_any: ["updateAnyPaymentPackage"],
    roles: [],
  },
  PayoutRequest: {
    get_any: ["getAnyPayoutRequest"],
    update_any: ["updateAnyPayoutRequest"],
    create_manual: ["createPayoutTransaction"],
    roles: ["client"],
  },
  Currency: {
    get_any: ["getAnyCurrency"],
    update_any: ["updateAnyCurrency"],
    roles: [],
  },
  SystemSettings: {
    get_any: ["getSystemSettings"],
    update_any: ["updateSystemSettings"],
    roles: [],
  },
  PayoutSystemSettings: {
    get_any: ["getAnyPayoutSystemSettings"],
    update_any: ["updateAnyPayoutSystemSettings"],
    roles: [],
  },
  Message: {
    get_any: ["getAnyMessage"],
    get_my: ["getMyMessage"],
    roles: ["admin", "client"],
  },
  MessageThread: {
    get_any: ["getAnyMessageThread"],
    get_my: ["getMyMessageThread"],
    roles: ["admin", "client"],
  },
  Verification: {
    get_any: ["getAnyUserInfo"],
    get_my: ["getMyUserInfo"],
    update_any: ["updateAnyUserInfo"],
    update_my: [],
    roles: ["client"],
  },
  SetPriceEdit: {
    update_any: ["updateAnyContentSubscriptionLevel", "updateAnyContentPrice"],
    update_my: ["updateMyContentSubscriptionLevel", "updateMyContentPrice"],
    roles: [],
  },
  UserReferring: {
    update_any: ["updateAnyUserReferring"],
    get_any: ["getAnyUserReferring"],
    roles: ["client"],
  },
  UserReferringPercent: {
    update_any: ["updateAnyUserReferring"],
    get_any: ["getAnyUserReferring"],
    roles: ["client"],
  },
  TalentAgent: {
    update_any: ["updateAnyTalentAgents"],
    get_any: ["getAnyTalentAgents"],
    roles: ["client"],
  },
};

export default config;
